import React, { useState, useEffect } from 'react';
import { BaseButton, Checkbox, useT } from '@repo/common';

import { ReactComponent as ArrowBottomIcon } from '@repo/common/assets/icons/20px/icon_20px_arrow-bottom.svg';
import { ReactComponent as ArrowTopIcon } from '@repo/common/assets/icons/20px/icon_20px_arrow-top.svg';

const MobileSortFilter = ({
  isSticky,
  onChange,
  filterState,
  isSearchPage = false,
}) => {
  const t = useT();
  const [isSortOpen, setIsSortOpen] = useState(false);

  const sortOptions = isSearchPage
    ? ['Most Relevant', 'Newest', 'Oldest', 'Most Popular']
    : ['Newest', 'Oldest', 'Most Popular'];
  const sortOptionLabelsKr = {
    'Most Relevant': '관련도순',
    Newest: '최신순',
    Oldest: '오래된순',
    'Most Popular': '인기순',
  };
  const initialSort = sortOptions.includes(filterState.sortBy)
    ? filterState.sortBy
    : sortOptions[0];
  const [selectedOption, setSelectedOption] = useState(initialSort);
  const [checked, setChecked] = useState(filterState.onlyTutor || false);

  useEffect(() => {
    setSelectedOption(filterState.sortBy);
    setChecked(filterState.onlyTutor);
  }, [filterState]);

  const handleOptionClick = (option) => {
    setSelectedOption(option);
    onChange({
      ...filterState,
      sortBy: option,
    });
    setIsSortOpen(false);
  };

  const handleCheckboxChange = () => {
    const newChecked = !checked;
    setChecked(newChecked);
    onChange({
      ...filterState,
      onlyTutor: newChecked,
    });
    setTimeout(() => {
      setIsSortOpen(false);
    }, 0);
  };

  return (
    <div
      className={`tabletH:hidden flex flex-col justify-center
          ${
            isSticky
              ? 'fixed top-0 left-0 right-0 z-40 pb-3 pt-0 bg-grayscale-gray01'
              : 'relative px-4 py-3'
          }
        `}
    >
      <BaseButton
        type='text'
        iconPosition='after'
        icon={isSortOpen ? <ArrowTopIcon /> : <ArrowBottomIcon />}
        bgclass='bg-grayscale-gray01 border-none'
        textclass='text-grayscale-gray07'
        hoverclass='hover:text-grayscale-gray07'
        activeclass='active:bg-grayscale-gray01 active:border-none active:text-grayscale-gray07'
        onClick={() => setIsSortOpen((prev) => !prev)}
      >
        {t(selectedOption, sortOptionLabelsKr[selectedOption] || selectedOption)}
      </BaseButton>

      {isSortOpen && (
        <div
          className={`tabletH:hidden flex flex-col justify-center ${
            isSticky ? 'items-start' : 'items-center'
          } px-8 pb-6`}
        >
          {sortOptions.map((option) => (
            <BaseButton
              key={option}
              type='text'
              hideIcon
              textclass='text-grayscale-gray07'
              bgclass='bg-grayscale-gray01'
              hoverclass='hover:bg-grayscale-gray02 hover:text-grayscale-gray07'
              activeclass='active:bg-grayscale-gray03 active:text-grayscale-gray07'
              width='100%'
              onClick={() => handleOptionClick(option)}
              leftalign={isSticky ? true : undefined}
            >
              {t(option, sortOptionLabelsKr[option] || option)}
            </BaseButton>
          ))}

          <Checkbox
            label={t('Only with tutor’s answer', '튜터 답변이 있는 질문만')}
            checked={checked}
            onChange={handleCheckboxChange}
            className={`${checked ? 'text-text-primary' : ''}`}
            boxClassName={
              checked
                ? 'bg-functional-success03 border-none'
                : 'bg-grayscale-gray00 border border-grayscale-gray03'
            }
          />
        </div>
      )}
    </div>
  );
};

export default MobileSortFilter;
